function Breadcrumb() {
  return null;
}

export default Breadcrumb;
